<template>
  <div>
    <div class="columns is-centered mt-3">
      <div class="column is-two-fifths">
        <div>
          <div class="mb-5">
            <div class="has-text-centered">
              <img src="https://merchant.accept.blue/branding/icon.png" alt="Logo"/>
            </div>
            <h1 class="is-size-2 has-text-centered mb-2">accept.blue Public PGP Key</h1>
            <div>This is accept.blue's current public PGP key for secure data transfers:</div>
          </div>

          <table class="table is-bordered is-striped is-fullwidth">
            <tbody>
            <tr>
              <td>Key ID</td>
              <td>2CAE 87E1 8E5A EA2A</td>
            </tr>
            <tr>
              <td>Fingerprint</td>
              <td>065E C802 BCFB 94CC 0DCB  B8F9 2CAE 87E1 8E5A EA2A</td>
            </tr>
            <tr>
              <td>Length</td>
              <td>4096</td>
            </tr>
            <tr>
              <td>Type</td>
              <td>RSA</td>
            </tr>
            <tr>
              <td>Expiration</td>
              <td>2025-06-26</td>
            </tr>
            <tr>
              <td colspan="2"><a href="https://accept.blue/support/#contact-form">Contact</a></td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="mt-6">
          <a id="pgp-key-download" download="accept_blue_0x8E5AEA2A_public.asc"
             :href="downloadLink">Download</a>
        </div>

        <div class="mt-6">
          <!-- The `<pre>` and `<code>` must be on the same line, or extra whitespace will be shown. -->
          <pre><code id="pgp-key">{{ publicKey }}</code></pre>
        </div>

        <footer class="has-text-centered mt-3 is-size-7">
          &copy;
          <span id="copyright-year">{{ year }}</span>
          accept.blue
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import publicKey from '../accept.blue_0x8E5AEA2A_public.asc?raw';

export default {
  name: 'pgp',
  data() {
    return {
      year: new Date().getFullYear(),
      publicKey,
    };
  },
  computed: {
    downloadLink() {
      return `data:application/octet-stream;charset=utf-8,${encodeURIComponent(this.publicKey)}`;
    },
  },
};
</script>
